
import AppHeader from '@/components/Header.vue'
import { defineComponent, computed, ref, getCurrentInstance, onMounted, reactive } from 'vue'
import { Icon, PullRefresh, Toast, Dialog, RadioGroup, Radio } from 'vant'
import { getBYJDetailByGuid, getImageUrlByUuid, byjOrderOperate } from '@/apis/service'
import appHost from '@/utils/app'
import { useStore } from 'vuex'
export default defineComponent({
  name: 'RepairOrder',
  components: {
    AppHeader,
    vanPullRefresh: PullRefresh,
    vanIcon: Icon,
    vanDialog: Dialog.Component,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
  },
  setup() {
    const loading = ref(false)
    const { proxy } = getCurrentInstance()
    const reserveMesaage = reactive({
      status: -1, // 备用机单状态
      status_text: '', // 状态文案
      guid: '',
      sn: '', // 备用机单号
      warehouse_name: '', // 仓库名称
      warehouse_type: '', // 仓库类型
      warehouse_type_text: '', // 仓库类型名称
      warehouse_guid: '', // 仓库guid
      client_phone: '',
      client_user: '',
      reserveList: [], // 备用机列表
      has_service_history: false, // 是否需要显示服务历史
      has_purchse_history: false, // 是否需要显示购买历史
      service_type: '', // 服务单类型
      service_type_text: '', // 标记服务单是保内 还是 保外
      is_show: false, // 是否显示购买时长按钮
    })
    const showUserDialog = ref(false)
    const checkedAgree = ref(false)
    const store = useStore() // vuestore
    const pagePaddingTop = computed(() => store.getters.pagePaddingTop)
    const onRefresh = async () => {
      await init()
      loading.value = false
    }
    const init = async () => {
      let param = {
        guid: proxy.$route.params.guid,
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await getBYJDetailByGuid(param)
        toast.clear()
        reserveMesaage.status = result.status
        reserveMesaage.status_text = result.status_text
        reserveMesaage.sn = result.sn
        reserveMesaage.guid = result.guid
        reserveMesaage.warehouse_name = result.warehouse_name
        reserveMesaage.warehouse_type_text = result.warehouse_type_text
        reserveMesaage.warehouse_type = result.warehouse_type
        reserveMesaage.warehouse_guid = result.warehouse_guid
        reserveMesaage.client_phone = result.client_phone
        reserveMesaage.client_user = result.client_user
        reserveMesaage.has_service_history = result.has_service_history
        reserveMesaage.has_purchse_history = result.has_purchse_history
        reserveMesaage.service_type = result.service_type
        reserveMesaage.service_type_text = result.service_type_text
        reserveMesaage.is_show = result.is_show
        for (let i = 0; i < result.detail.length; i++) {
          try {
            result.detail[i].url = await getImageByGuid(result.detail[i].image_guid)
          } catch (error) {
            console.log(error)
          }
        }
        reserveMesaage.reserveList = result.detail || []
      } catch (error: any) {
        let message = error && error.message ? error.message : '操作失败'
        toast.clear()
        Toast(message)
      }
    }
    const getImageByGuid = async (guid: string) => {
      let param = {
        res_uids: [guid],
      }
      try {
        let result: any = await getImageUrlByUuid(param)
        return result[0].url
      } catch (error) {
        return ''
      }
    }
    const handleBuyPage = () => {
      if (reserveMesaage.sn) {
        proxy.$router.replace({
          path: `/buyusetime/${reserveMesaage.sn}/${reserveMesaage.guid}`,
          query: proxy.$route.query,
        })
        return
      }
      Toast('数据错误，请联系管理员')
    }
    // 服务历史
    const handleServiceHistory = () => {
      if (!reserveMesaage.sn) {
        Toast('数据错误，请联系管理员')
        return
      }
      proxy.$router.push({ path: `/standby/servicehistories/${reserveMesaage.sn}` })
    }
    // 购买记录
    const handleBuyRecord = () => {
      if (!reserveMesaage.sn) {
        Toast('数据错误，请联系管理员')
        return
      }
      proxy.$router.push({ path: `/standby/purchases/${reserveMesaage.sn}` })
    }
    // 更改备用机状态 2-确认使用 5-确认收货 6-确认归还 8-不使用
    const handleChangeStatus = async (step: number) => {
      if (step == 8) {
        Dialog.confirm({
          title: '拒绝',
          message: '确认不需要使用备用机？',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          className: 'reserve-dialog',
          width: 304,
        })
          .then(async () => {
            let toast = Toast({
              type: 'loading',
              message: '加载中...',
              forbidClick: true,
              duration: 0,
            })
            try {
              let result = await byjOrderOperate({ number: reserveMesaage.sn, step: 8 })
              Dialog.close()
              toast.clear()
              Toast('操作成功')
              await init()
            } catch (error: any) {
              Dialog.close()
              let message = error && error.message ? error.message : '操作失败'
              toast.clear()
              Toast(message)
            }
          })
          .catch(() => {
            Dialog.close()
          })
      }
      if (step == 2) {
        let toast = Toast({
          type: 'loading',
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        })
        try {
          let result = await byjOrderOperate({ number: reserveMesaage.sn, step: 2 })
          showUserDialog.value = false
          toast.clear()
          Toast('操作成功')
          await init()
        } catch (error: any) {
          showUserDialog.value = false
          let message = error && error.message ? error.message : '操作失败'
          toast.clear()
          Toast(message)
        }
      }
      if (step == 5) {
        Dialog.confirm({
          title: '确认收货',
          message: '为了保障你的权益，请收到备用机确认无误后再确认收货',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          className: 'reserve-dialog',
          width: 304,
        })
          .then(async () => {
            let toast = Toast({
              type: 'loading',
              message: '加载中...',
              forbidClick: true,
              duration: 0,
            })
            try {
              let result = await byjOrderOperate({ number: reserveMesaage.sn, step: 5 })
              Dialog.close()
              toast.clear()
              Toast('操作成功')
              await init()
            } catch (error: any) {
              Dialog.close()
              let message = error && error.message ? error.message : '操作失败'
              toast.clear()
              Toast(message)
            }
          })
          .catch(() => {
            Dialog.close()
          })
      }
      if (step == 7) {
        Dialog.confirm({
          title: '确认归还',
          message: '确认已将备用机归还至网点',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          className: 'reserve-dialog',
          width: 304,
        })
          .then(async () => {
            let toast = Toast({
              type: 'loading',
              message: '加载中...',
              forbidClick: true,
              duration: 0,
            })
            try {
              let result = await byjOrderOperate({ number: reserveMesaage.sn, step: 7 })
              Dialog.close()
              toast.clear()
              Toast('操作成功')
              await init()
            } catch (error: any) {
              Dialog.close()
              let message = error && error.message ? error.message : '操作失败'
              toast.clear()
              Toast(message)
            }
          })
          .catch(() => {
            Dialog.close()
          })
      }
    }
    const handleClikBack = () => {
      if (proxy.$route.query.from && proxy.$route.query.from == 'app') {
        appHost.goAppBack()
        return
      }
      proxy.$router.back()
    }
    // 跳转到网点详情
    const handleNetWorkDetail = () => {
      proxy.$router.push({
        path: `/fault/pointdetail/${reserveMesaage.warehouse_guid}`,
        query: { type: reserveMesaage.warehouse_type },
      })
    }
    // 打开弹窗
    const handleOpenUseDialog = () => {
      checkedAgree.value = false
      showUserDialog.value = true
    }
    // 点击取消弹窗
    const handleCancelUse = () => {
      showUserDialog.value = false
    }
    // 点击确定按钮
    const handleConfirmClick = () => {
      if (checkedAgree.value) {
        handleChangeStatus(2)
        return
      }
      Toast('请同意合同内容')
    }
    // 关闭窗口前回调
    const handleBeforeClose = () => {
      return false
    }
    const handleProtoc = () => {
      proxy.$router.push({
        path: '/protoc',
        query: {
          title: '备用产品使用合同',
          url: 'https://app.xag.cn/help_doc/2fec19dc-9d74-413a-a8f1-2b26e9b15f5a',
        },
      })
    }
    const handleRuleProtoc = () => {
      proxy.$router.push({
        path: '/protoc',
        query: {
          title: '备用产品使用规则',
          url: 'https://app.xag.cn/help_doc/4ed2f685-cb1c-446c-b0af-271fa17141ae',
        },
      })
    }
    onMounted(() => {
      init()
    })
    return {
      loading,
      reserveMesaage,
      pagePaddingTop,
      showUserDialog,
      checkedAgree,
      onRefresh,
      handleBuyPage,
      handleServiceHistory,
      handleBuyRecord,
      handleChangeStatus,
      handleClikBack,
      handleNetWorkDetail,
      handleOpenUseDialog,
      handleCancelUse,
      handleConfirmClick,
      handleBeforeClose,
      handleProtoc,
      handleRuleProtoc,
    }
  },
})
